define.alias("shared/components/shared/ui/switcher/trigger", "preview-grid/components/shared/ui/switcher/trigger");